import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Box, Container, Paper } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    container: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        padding: '3rem',
        textAlign: 'center',
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    },
    heading: {
        fontSize: '3rem',
        fontWeight: 700,
        color: '#26344a',
        marginBottom: '1rem',
    },
    paragraph: {
        fontSize: '1.6rem',
        color: '#7a7a7a',
    },
}));

export default function NotFound() {
    const classes = useStyles();

    return (
        <Container className={classes.container}>
            <Paper className={classes.paper} elevation={1}>
                <Typography variant="h1" className={classes.heading}>
                    Page Not Found
                </Typography>
                <Typography variant="body1" className={classes.paragraph}>
                    ページが見つかりません
                </Typography>
            </Paper>
        </Container>
    )
}
